import "core-js/modules/es7.object.get-own-property-descriptors";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/panzhijing/\u86CB\u5377\u79D1\u6280/danjuan-admin/node_modules/_@babel_runtime-corejs2@7.26.0@@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "/Users/panzhijing/\u86CB\u5377\u79D1\u6280/danjuan-admin/node_modules/_@babel_runtime-corejs2@7.26.0@@babel/runtime-corejs2/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as _ from 'lodash';
export default {
  props: {
    config: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    searchData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    checkLoading: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      obj: {},
      timer: null,
      inputObj: {},
      initializeData: {}
    };
  },
  watch: {
    // obj 改变 更新 $emit
    obj: {
      handler: function handler(val) {
        this.throttle(500);
        var params = _objectSpread(_objectSpread({}, this.inputObj), val);
        this.$emit('update:searchData', params);
      },
      deep: true // 是否监听对象内部属性的变化
    },
    inputObj: {
      handler: function handler(val) {
        var params = _objectSpread(_objectSpread({}, this.obj), val);
        for (var paramsKey in params) {
          if (!params[paramsKey]) {
            delete params[paramsKey];
          }
        }
        this.$emit('update:searchData', params);
      },
      deep: true // 是否监听对象内部属性的变化
    }
  },
  mounted: function mounted() {
    if (this.searchData) {
      this.initializeData = _.cloneDeep(this.searchData);
      this.obj = _objectSpread({}, this.searchData);
    }
    this.initData(this.config);
  },
  methods: {
    /**
     * 处理数据
     * @param value 配置数据
     * @param ruleForm 插入数据
     * @returns {{}}
     */
    initData: function initData(configList) {
      var _this = this;
      var obj = {};
      if (configList && configList.length > 0) {
        configList.forEach(function (val) {
          if (val.type === 'requestSelect') {
            if (_this.$can('SHOWMENU', 'callmgr')) {
              _this.requestData(val.request).then(function (res) {
                if (val.format && Object.keys(val.format).length > 0) {
                  if (res && res.length > 0) {
                    val.options = res.map(function (value) {
                      return {
                        value: val.format.value ? value[val.format.value] : value,
                        label: val.format.label ? value[val.format.label] : value
                      };
                    });
                  }
                } else {
                  val.options = res;
                }
              }).catch(function () {});
            }
          }
        });
      }
      return obj;
    },
    submit: function submit() {
      var params = _objectSpread(_objectSpread({}, this.inputObj), this.obj);
      this.$emit('check', params);
    },
    check: function check() {
      var params = _objectSpread(_objectSpread({}, this.inputObj), this.obj);
      this.$emit('check', params);
    },
    /**
     * 部分重置
     */
    reset: function reset() {
      var params = _objectSpread(_objectSpread({}, this.inputObj), this.obj);
      this.$emit('check', params);
    },
    /**
     * 重置全部
     */
    resetAll: function resetAll() {
      this.obj = _objectSpread({}, this.initializeData);
      this.inputObj = {};
    },
    /**
     * 函数节流
     */
    throttle: function throttle(wait) {
      var _this2 = this;
      if (!this.timer) {
        clearTimeout(this.timer);
        this.timer = setTimeout(function () {
          _this2.check();
          _this2.timer = null;
        }, wait);
      }
    },
    /**
     * 请求数据
     * @param request
     * @param params
     * @returns {Promise<*[]>}
     */
    requestData: function () {
      var _requestData = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(request, params) {
        var requestData, da, status, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              requestData = [];
              if (!request) {
                _context.next = 13;
                break;
              }
              _context.prev = 2;
              _context.next = 5;
              return request();
            case 5:
              da = _context.sent;
              status = da.status, data = da.data;
              if (status === '0') {
                requestData = data;
              }
              _context.next = 13;
              break;
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](2);
              this.$message.error('数据请求失败');
            case 13:
              return _context.abrupt("return", requestData);
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[2, 10]]);
      }));
      function requestData(_x, _x2) {
        return _requestData.apply(this, arguments);
      }
      return requestData;
    }()
  }
};